import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock } from 'lucide-react';
import GeometricPattern from './GeometricPattern';
import { COMPANY } from '../data/mock';
import { brandConfig } from '../brandConfig';

export default function Footer() {
  return (
    <footer style={{
      background: '#0A1628', color: '#FBF8F0', position: 'relative',
      overflow: 'hidden', padding: '90px 0 48px',
    }}>
      <GeometricPattern color="#C9A84C" opacity={0.04} size={100} />
      <div style={{
        maxWidth: 'var(--container)', margin: '0 auto', padding: '0 var(--gutter)',
        position: 'relative', zIndex: 2,
      }}>
        <div className="footer-grid" style={{
          display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 48,
        }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 18 }}>
              <img src="/logo.png" alt={brandConfig.companyName} style={{ height: 64, width: 'auto', objectFit: 'contain' }} />
            </div>
            <div style={{ fontFamily: 'Amiri', fontSize: 20, fontWeight: 700, color: '#C9A84C', letterSpacing: '0.08em' }}>
              {brandConfig.companyName.toUpperCase()}
            </div>
            <div className="arabic-text" style={{ fontSize: 14, color: 'rgba(251,248,240,0.6)', marginTop: 4 }}>
              {COMPANY.arabicName}
            </div>
            <div style={{ fontFamily: 'Inter', fontSize: 13, color: 'rgba(251,248,240,0.7)', marginTop: 16, lineHeight: 1.7 }}>
              Your trusted partner for sacred travel from Addis Ababa. Spirituality. Comfort. Trust.
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 20 }}>
              <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#22C55E', boxShadow: '0 0 0 3px rgba(34,197,94,0.25)' }} />
              <span style={{ fontFamily: 'Inter', fontSize: 12, fontWeight: 500, color: '#FBF8F0' }}>
                Open 24 Hours
              </span>
            </div>
          </div>

          <div>
            <div style={{ fontFamily: 'Amiri', fontSize: 16, fontWeight: 700, color: '#C9A84C', marginBottom: 20, letterSpacing: '0.06em' }}>
              Services
            </div>
            {['Umrah Packages', 'Flight Tickets', 'Visa Services', 'Hotel Booking', 'Transport'].map((s) => (
              <Link key={s} to="/services" style={{
                display: 'block', fontFamily: 'Inter', fontSize: 14,
                color: 'rgba(251,248,240,0.75)', textDecoration: 'none',
                marginBottom: 10, transition: 'color 0.2s',
              }} onMouseEnter={(e) => (e.target.style.color = '#C9A84C')}
                 onMouseLeave={(e) => (e.target.style.color = 'rgba(251,248,240,0.75)')}>
                {s}
              </Link>
            ))}
          </div>

          <div>
            <div style={{ fontFamily: 'Amiri', fontSize: 16, fontWeight: 700, color: '#C9A84C', marginBottom: 20, letterSpacing: '0.06em' }}>
              Quick Links
            </div>
            {[
              { l: 'Home', t: '/' }, { l: 'Packages', t: '/packages' },
              { l: 'Gallery', t: '/gallery' }, { l: 'About Us', t: '/about' },
              { l: 'Contact', t: '/contact' }, { l: 'Book Now', t: '/contact' },
            ].map((s) => (
              <Link key={s.l} to={s.t} style={{
                display: 'block', fontFamily: 'Inter', fontSize: 14,
                color: 'rgba(251,248,240,0.75)', textDecoration: 'none', marginBottom: 10,
              }} onMouseEnter={(e) => (e.target.style.color = '#C9A84C')}
                 onMouseLeave={(e) => (e.target.style.color = 'rgba(251,248,240,0.75)')}>
                {s.l}
              </Link>
            ))}
            <a href="/admin.html" style={{
              display: 'block', fontFamily: 'Inter', fontSize: 14,
              color: 'rgba(251,248,240,0.75)', textDecoration: 'none', marginBottom: 10,
            }} onMouseEnter={(e) => (e.target.style.color = '#C9A84C')}
               onMouseLeave={(e) => (e.target.style.color = 'rgba(251,248,240,0.75)')}>
              {brandConfig.cmsDashboardTitle}
            </a>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ fontFamily: 'Amiri', fontSize: 16, fontWeight: 700, color: '#C9A84C', marginBottom: 20, letterSpacing: '0.06em' }}>
              Contact
            </div>
            <a href={`tel:${COMPANY.phoneIntl}`} style={{
              fontFamily: 'Amiri', fontSize: 18, fontWeight: 700, color: '#C9A84C',
              textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 10,
            }}>
              <Phone size={18} style={{ flexShrink: 0 }} /> {COMPANY.phoneDisplay}
            </a>
            <a href={`mailto:${brandConfig.contactEmail}`} style={{
              fontFamily: 'Inter', fontSize: 13, color: '#FBF8F0', textDecoration: 'none',
              display: 'flex', alignItems: 'center', gap: 10, marginTop: 12,
            }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
              </svg>
              <span style={{ wordBreak: 'break-all' }}>{brandConfig.contactEmail}</span>
            </a>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 12, color: '#FBF8F0', fontSize: 13 }}>
              <Clock size={14} color="#C9A84C" style={{ flexShrink: 0 }} /> Open 24 Hours
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 12, color: '#FBF8F0', fontSize: 13 }}>
              <MapPin size={14} color="#C9A84C" style={{ flexShrink: 0 }} /> {COMPANY.location}
            </div>

            <div style={{ display: 'flex', gap: 16, marginTop: 24 }}>
              <a href={brandConfig.facebookLink} target="_blank" rel="noreferrer" style={{ color: '#C9A84C', display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none', fontSize: 13 }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3.65l.35-4H14V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
              <a href={brandConfig.instagramLink} target="_blank" rel="noreferrer" style={{ color: '#C9A84C', display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none', fontSize: 13 }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
              <a href={COMPANY.social.tiktok} target="_blank" rel="noreferrer" style={{ color: '#C9A84C', display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none', fontSize: 13 }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5v3a3 3 0 0 1-3-3" />
                </svg>
              </a>
            </div>

            <div className="arabic-text" style={{ marginTop: 20, fontSize: 16, color: 'rgba(201,168,76,0.55)' }}>
              {COMPANY.bismillah}
            </div>
            <Link to="/contact" style={{
              display: 'block', textAlign: 'center', marginTop: 18,
              background: '#C9A84C', color: '#0A1628', padding: '12px 16px',
              fontFamily: 'Inter', fontWeight: 600, fontSize: 13,
              textDecoration: 'none', letterSpacing: '0.1em', textTransform: 'uppercase',
              borderRadius: 999,
            }}>
              Book Now →
            </Link>
          </div>
        </div>

        <div style={{
          borderTop: '1px solid rgba(201,168,76,0.15)', marginTop: 60, paddingTop: 28,
          display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16,
        }}>
          <div style={{ fontFamily: 'Inter', fontSize: 12, color: 'rgba(251,248,240,0.4)' }}>
            © 2025 {brandConfig.companyName} · Addis Ababa, Ethiopia
          </div>
          <div className="arabic-text" style={{ fontSize: 14, color: 'rgba(201,168,76,0.4)' }}>
            {COMPANY.arabicName} — {COMPANY.arabicMotto}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .footer-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 32px !important; }
        }
        @media (max-width: 540px) {
          .footer-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
}
